<template lang="html">
  <transition-group tag="span" class="has-error help-block error-block text-error" name="fade"
                    v-show="hasErrors"><span
      v-for="(message, idx) in messages" :key="'error' + idx">{{ message }}</span></transition-group>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {ModelErrors} from 'capitalist-shared/src/core/model';

@Component({
  name: 'bo-error-message-block',
})
export default class BoErrorMessageBlock extends Vue {
  @Prop({ required: true })
  errors!: ModelErrors

  @Prop({ required: true, default: '' })
  attribute!: string

  get attributes(): string[] {
    return this.attribute.split('|');
  }

  get messages(): any {
    const messages: Array<string> = [];
    for (const attribute of this.attributes) if (this.errors.has(attribute)) messages.push(this.errors.get(attribute));
    return messages;
  }

  get hasErrors(): boolean {
    for (const attribute of this.attributes) if (this.errors.has(attribute)) return true;
    return false;
  }
}
</script>

<style scoped lang="less">

</style>
